import { TestIdDomain } from 'constants/testIds';

const AiChatTestIdsScope = {
  ACTION_STEP: 'action-step',
  ACTION_STEP_GROUP_SUMMARY: 'action-step-group-summary',
  AI_BOT_MESSAGE: 'ai-bot-message',
  AI_CHAT_CONTENT: 'ai-chat-content',
  AI_CHAT_HEADER: 'ai-chat-header',
  BOT_MESSAGE_LIST_CONTENT: 'bot-message-list-content',
  CONFIRM_ACTION_CONTENT: 'confirm-action-content',
  CONFIRM_ACTIONS_CONTENT: 'confirm-actions-content',
  GUIDELINE_FULL_VIEW: 'guideline-full-view',
  TOOL_EXECUTION_NOTIFICATION: 'tool-execution-notification',
  USER_MESSAGE: 'user-message',
};

export const AiChatTestIds = {
  // ActionStepGroupSummary
  ACTION_STEP_GROUP_SUMMARY_ACCORDION: `${AiChatTestIdsScope.ACTION_STEP_GROUP_SUMMARY}.accordion`,
  ACTION_STEP_GROUP_SUMMARY_DESCRIPTION: `${AiChatTestIdsScope.ACTION_STEP_GROUP_SUMMARY}.description`,
  ACTION_STEP_GROUP_SUMMARY_PROGRESS_TEXT: `${AiChatTestIdsScope.ACTION_STEP_GROUP_SUMMARY}.progress-text`,
  ACTION_STEP_GROUP_SUMMARY_STATUS_LINE: `${AiChatTestIdsScope.ACTION_STEP_GROUP_SUMMARY}.status-line`,
  ACTION_STEP_GROUP_SUMMARY_TITLE: `${AiChatTestIdsScope.ACTION_STEP_GROUP_SUMMARY}.title`,

  // ActionPlan
  ACTION_PLAN_WRAPPER: 'action-plan.wrapper',
  ACTION_PLAN_CANCEL_BUTTON: 'action-plan.cancel-button',
  ACTION_PLAN_CARD_HEADER: 'action-plan.card-header',
  ACTION_PLAN_CARD_TOGGLE: 'action-plan.card-toggle',
  ACTION_PLAN_CARD_BODY: 'action-plan.card-body',
  ACTION_PLAN_CARD_PROGRESS: 'action-plan.card-progress',

  // ActionStep
  ACTION_STEP_ACCORDION: `${AiChatTestIdsScope.ACTION_STEP}.accordion`,
  ACTION_STEP_DESCRIPTION: `${AiChatTestIdsScope.ACTION_STEP}.description`,
  ACTION_STEP_SUMMARY_WRAPPER: `${AiChatTestIdsScope.ACTION_STEP}.summary-wrapper`,
  ACTION_STEP_TITLE: `${AiChatTestIdsScope.ACTION_STEP}.title`,

  // AiChatContent
  AI_CHAT_CONTENT: `${TestIdDomain.AI_CHAT}.content`,
  AI_CHAT_CONTENT_MESSAGE_LIST: `${AiChatTestIdsScope.AI_CHAT_CONTENT}.message-list`,
  AI_CHAT_CONTENT_SCROLL_TO_BOTTOM: `${AiChatTestIdsScope.AI_CHAT_CONTENT}.scroll-to-bottom`,

  // AiChatActivityBar
  AI_CHAT_ACTIVITY_BAR: `${TestIdDomain.AI_CHAT}.activity-bar`,

  // AiChatFooter
  AI_CHAT_FOOTER: `${TestIdDomain.AI_CHAT}.footer`,

  // AiChatHeader
  AI_CHAT_HEADER: `${AiChatTestIdsScope.AI_CHAT_HEADER}.wrapper`,
  AI_CHAT_HEADER_STATUS_BAR: `${AiChatTestIdsScope.AI_CHAT_HEADER}.status-bar`,
  AI_CHAT_HEADER_STATUS_SUMMARY: `${AiChatTestIdsScope.AI_CHAT_HEADER}.status-summary`,
  AI_CHAT_HEADER_CONFIG_NAME: `${AiChatTestIdsScope.AI_CHAT_HEADER}.config-name`,
  AI_CHAT_HEADER_CONFIG_MODEL: `${AiChatTestIdsScope.AI_CHAT_HEADER}.config-model`,
  AI_CHAT_HEADER_CONFIG_SWITCHER_BUTTON: `${AiChatTestIdsScope.AI_CHAT_HEADER}.config-switcher-button`,
  AI_CHAT_HEADER_CONFIG_SWITCHER_MENU: `${AiChatTestIdsScope.AI_CHAT_HEADER}.config-switcher-menu`,
  AI_CHAT_HEADER_CONFIG_SKELETON: `${AiChatTestIdsScope.AI_CHAT_HEADER}.config-skeleton`,
  AI_CHAT_HEADER_CLOSE_BUTTON: `${AiChatTestIdsScope.AI_CHAT_HEADER}.close-button`,

  // AiChatInput
  AI_CHAT_INPUT: `${TestIdDomain.AI_CHAT}.input`,
  AI_CHAT_INPUT_FIELD: `${TestIdDomain.AI_CHAT}.input-field`,
  AI_CHAT_INPUT_SEND_BUTTON: `${TestIdDomain.AI_CHAT}.input.send-button`,
  AI_CHAT_INPUT_STOP_BUTTON: `${TestIdDomain.AI_CHAT}.input.stop-button`,

  // AiChatPanel
  AI_CHAT_PANEL: `${TestIdDomain.AI_CHAT}.panel`,
  AI_CHAT_PANEL_CONTENT: 'ai-chat-panel.content',

  // BotMessage
  AI_BOT_MESSAGE: `${AiChatTestIdsScope.AI_BOT_MESSAGE}.wrapper`,
  AI_BOT_MESSAGE_CONTENT_WRAPPER: `${AiChatTestIdsScope.AI_BOT_MESSAGE}.message-content-wrapper`,
  AI_BOT_MESSAGE_CONTENT_LIST: `${AiChatTestIdsScope.AI_BOT_MESSAGE}.message-content-list`,
  AI_BOT_MESSAGE_STREAMING_CARET: `${AiChatTestIdsScope.AI_BOT_MESSAGE}.streaming-caret`,
  AI_BOT_MESSAGE_CITATION_BADGE: `${AiChatTestIdsScope.AI_BOT_MESSAGE}.citation-badge`,
  AI_BOT_MESSAGE_CITATION_DETAIL: `${AiChatTestIdsScope.AI_BOT_MESSAGE}.citation-detail`,
  AI_BOT_MESSAGE_CITATION_VIEW_GUIDELINE_BUTTON: `${AiChatTestIdsScope.AI_BOT_MESSAGE}.citation-view-guideline-button`,
  AI_BOT_MESSAGE_FAILURE: `${AiChatTestIdsScope.AI_BOT_MESSAGE}.failure`,
  AI_BOT_MESSAGE_FAILURE_RETRY_BUTTON: `${AiChatTestIdsScope.AI_BOT_MESSAGE}.failure-retry-button`,
  AI_BOT_MESSAGE_FEEDBACK: `${AiChatTestIdsScope.AI_BOT_MESSAGE}.feedback`,
  AI_BOT_MESSAGE_FEEDBACK_THUMBS_UP: `${AiChatTestIdsScope.AI_BOT_MESSAGE}.feedback-thumbs-up`,
  AI_BOT_MESSAGE_FEEDBACK_THUMBS_DOWN: `${AiChatTestIdsScope.AI_BOT_MESSAGE}.feedback-thumbs-down`,

  // ChatStatusMessage
  CHAT_STATUS_MESSAGE: `${TestIdDomain.AI_CHAT}.chat-status-message`,

  // AssistantSlowWarning
  ASSISTANT_SLOW_WARNING: `${TestIdDomain.AI_CHAT}.assistant-slow-warning`,

  // ConfirmActionContent
  CONFIRM_ACTION_CONTENT: `${AiChatTestIdsScope.CONFIRM_ACTION_CONTENT}.wrapper`,
  CONFIRM_ACTION_CONTENT_SUBMIT_BUTTON: `${AiChatTestIdsScope.CONFIRM_ACTION_CONTENT}.submit-button`,
  CONFIRM_ACTION_CONTENT_CANCEL_BUTTON: `${AiChatTestIdsScope.CONFIRM_ACTION_CONTENT}.cancel-button`,

  // ConfirmActionsContent
  CONFIRM_ACTIONS_CONTENT_SUBMIT_BUTTON: `${AiChatTestIdsScope.CONFIRM_ACTIONS_CONTENT}.submit-button`,
  CONFIRM_ACTIONS_CONTENT_CANCEL_BUTTON: `${AiChatTestIdsScope.CONFIRM_ACTIONS_CONTENT}.cancel-button`,

  // GuidelineFullView
  GUIDELINE_FULL_VIEW_DRAWER: `${AiChatTestIdsScope.GUIDELINE_FULL_VIEW}.drawer`,
  GUIDELINE_FULL_VIEW_ASK_BUTTON: `${AiChatTestIdsScope.GUIDELINE_FULL_VIEW}.ask-button`,
  GUIDELINE_FULL_VIEW_CLOSE_BUTTON: `${AiChatTestIdsScope.GUIDELINE_FULL_VIEW}.close-button`,

  // ToolExecutionNotification
  TOOL_EXECUTION_NOTIFICATION_DISMISS_BUTTON: `${AiChatTestIdsScope.TOOL_EXECUTION_NOTIFICATION}.dismiss-button`,

  // ListContent
  BOT_MESSAGE_LIST_CONTENT: `${AiChatTestIdsScope.BOT_MESSAGE_LIST_CONTENT}.wrapper`,
  BOT_MESSAGE_LIST_CONTENT_LIST_ITEM: `${AiChatTestIdsScope.BOT_MESSAGE_LIST_CONTENT}.list-item`,

  // MessageStatus
  BOT_MESSAGE_STATUS: 'bot-message.status',

  // TextContent
  BOT_MESSAGE_TEXT_CONTENT: 'bot-message-text-content.wrapper',

  // ToolConfirmationCard
  TOOL_CONFIRMATION_CARD: 'tool-confirmation-card.wrapper',
  TOOL_CONFIRMATION_CARD_TITLE: 'tool-confirmation-card.title',
  TOOL_CONFIRMATION_CARD_DETAIL: 'tool-confirmation-card.detail',
  TOOL_CONFIRMATION_CARD_APPROVE_BUTTON: 'tool-confirmation-card.approve-button',
  TOOL_CONFIRMATION_CARD_DECLINE_BUTTON: 'tool-confirmation-card.decline-button',
  TOOL_CONFIRMATION_CARD_REASON_INPUT: 'tool-confirmation-card.reason-input',
  TOOL_CONFIRMATION_CARD_REASON_SUBMIT: 'tool-confirmation-card.reason-submit',
  TOOL_CONFIRMATION_CARD_REASON_CANCEL: 'tool-confirmation-card.reason-cancel',
  TOOL_CONFIRMATION_CARD_SLA_GROUP_SELECT: 'tool-confirmation-card.sla-group-select',
  TOOL_CONFIRMATION_CARD_ADJUST_SUMMARY: 'tool-confirmation-card.adjust-summary',
  TOOL_CONFIRMATION_CARD_RESULT: 'tool-confirmation-card.result',
  TOOL_CONFIRMATION_CARD_RESULT_TOGGLE: 'tool-confirmation-card.result-toggle',
  TOOL_CONFIRMATION_CARD_ERROR: 'tool-confirmation-card.error',
  TOOL_CONFIRMATION_CARD_CANCELLED: 'tool-confirmation-card.cancelled',
  TOOL_CONFIRMATION_CARD_TIMED_OUT: 'tool-confirmation-card.timed-out',

  // UserMessage
  USER_MESSAGE: `${TestIdDomain.AI_CHAT}.${AiChatTestIdsScope.USER_MESSAGE}`,
  USER_MESSAGE_CONTENT: `${AiChatTestIdsScope.USER_MESSAGE}.content`,
  USER_MESSAGE_TOOLS: `${AiChatTestIdsScope.USER_MESSAGE}.tools`,

  // UserMessageAvatar
  USER_MESSAGE_AVATAR: 'user-message-avatar.fallback',
};
